import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';
import { CheckBox } from '@mui/icons-material';

function AdminDashboardUsers() {

    function redirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [users, setUsers] = useState([]);

    const [editingUser, setEditingUser] = useState("");

    const [editingUserEmail, setEditingUserEmail] = useState("");

    const [editingUserTokens, setEditingUserTokens] = useState("");

    const [editingMembership, setEditingMembership] = useState("");

    const [editingMembershipAmount, setEditingMembershipAmount] = useState("");

    const [editingStripeCustomerId, setEditingStripeCustomerId] = useState("");

    const [showMembersOnly, setShowMembersOnly] = useState(false);

    function handleEditingUserEmailChange(event) {
        setEditingUserEmail(event.target.value);
    }

    function handleEditingUserTokensChange(event) {
        setEditingUserTokens(event.target.value);
    }

    function handleEditingMembershipChange(event) {
        setEditingMembership(event.target.checked);
    }
    
    function handleEditingMembershipAmountChange(event) {
        setEditingMembershipAmount(event.target.value);
    }

    function handleEditingStripeCustomerId(event) {
        setEditingStripeCustomerId(event.target.value)
    }

    useEffect(() => {
        refreshUsers();
    }, []);

    function refreshUsers() {
        fetch(karmaContext.getURLBasePath() + 'user?requestAllUsers=true', {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setUsers(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function saveEditingUser(event) {

        event.preventDefault();

        console.log("Saving editing user: " + editingUser + ", email: " + editingUserEmail + ", tokens: " + editingUserTokens);

        fetch(karmaContext.getURLBasePath() + 'user/' + editingUser, {
            method: 'PATCH',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "email": editingUserEmail,
                "tokens": editingUserTokens,
                "member": editingMembership,
                "memberSubscriptionAmount": editingMembershipAmount[0] === "£" ? editingMembershipAmount.substring(1) : editingMembershipAmount,
                "stripeCustomerId": editingStripeCustomerId
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setEditingUser("");
                setEditingUserEmail("");
                setEditingUserTokens("");
                setEditingMembership(false);
                setEditingStripeCustomerId("");
                refreshUsers();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function printUserRows() {
        // Print the username of each user in users array
        return (
            <>
                {users.filter((user) => (user.member || !showMembersOnly)).map((user) => {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                            <Typography variant="body2" component="div" gutterBottom>
                                id={user.id} | {user.username} | {user.email} | {user.tokens} tokens | {user.member ? "Member" : "Not Member"}
                            </Typography>
                            <Button
                                onClick={() => { setEditingUserFromList(user.username) }}
                                variant="contained"
                                sx={{ backgroundColor: "rgba(221, 221, 221, 0.875)", color: "black", fontSize: "0.8rem", width: "5rem", height: "2.0rem" }}>
                                Edit
                            </Button>
                        </Box>
                    );
                })}
            </>
        );
    }

    function printUserEdit() {
        // Print the username of each user in users array
        return (
            <>
                {users.map((user) => {
                    if (user.username === editingUser) {
                        return (
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                                <form
                                    onSubmit={saveEditingUser}
                                >
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="id"
                                        label="ID"
                                        defaultValue={user.id}
                                        variant='standard'
                                        onChange={null}
                                        size="small"
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="username"
                                        label="Username"
                                        defaultValue={user.username}
                                        variant='standard'
                                        onChange={null}
                                        size="small"
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="email"
                                        label="Email"
                                        defaultValue={user.email}
                                        variant='standard'
                                        onChange={handleEditingUserEmailChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="tokens"
                                        label="Tokens"
                                        defaultValue={user.tokens}
                                        variant='standard'
                                        onChange={handleEditingUserTokensChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="tokensAllocated"
                                        label="Tokens Allocated"
                                        defaultValue={(user.tokensAllocatedToCycle)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="gbpGivenByUserAllTime"
                                        label="GBP Given All-time"
                                        defaultValue={"£" + (user.gbpGivenByUserAllTime)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="memberSubscriptionAmount"
                                        label="Member Subscription Amount"
                                        defaultValue={"£" + (user.memberSubscriptionAmount)}
                                        variant='standard'
                                        size="small"
                                        onChange={handleEditingMembershipAmountChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="membershipCancelled"
                                        label="Membership Cancelled"
                                        defaultValue={(user.membershipCancelled)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="stripeCustomerId"
                                        label="Stripe Customer Id"
                                        defaultValue={(user.stripeCustomerId)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleEditingStripeCustomerId}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="membershipStartDateTime"
                                        label="Membership Started"
                                        defaultValue={(user.membershipStartDateTime)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                    <br />
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' }, marginTop: "0.5rem" }}
                                        id="membershipEndDateTime"
                                        label="Membership Ended"
                                        defaultValue={(user.membershipEndDateTime)}
                                        variant='standard'
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                    <br />
                                    <FormControlLabel
                                        sx={{ marginRight: "2.5rem", marginBottom: "1.5rem", marginTop: "0.5rem"}}
                                        control={
                                            <Checkbox
                                                sx={{
                                                    '& .MuiSvgIcon-root': {
                                                        color: 'white',
                                                    },
                                                }}
                                                id="isMember"
                                                defaultChecked={user.member}
                                                onChange={handleEditingMembershipChange}
                                                size="small"
                                            />
                                        }
                                        label="Member" // Your label text goes here
                                        labelPlacement="end" // You can change label placement if needed (start, top, bottom)
                                    />
                                    <br />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{ backgroundColor: "rgba(221, 221, 221, 0.875)", color: "black", fontSize: "0.8rem", width: "5rem", height: "2.0rem" }}>
                                        Save
                                    </Button>
                                </form>
                            </Box>
                        );
                    }
                    else {
                        return null;
                    }
                })}
            </>
        );
    }

    function setEditingUserFromList(username) {
        users.map((user) => {
            if (user.username === username) {
                setEditingUserEmail(user.email);
                setEditingUserTokens(user.tokens);
                setEditingMembership(user.member);
            }
        });
        setEditingUser(username);
    }

    redirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    usersEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Users
                    </Typography>

                    <br />
                    { editingUser === "" ? 
                    <Button
                        onClick={() => { setShowMembersOnly(!showMembersOnly) }}
                        variant="contained"
                        sx={{ backgroundColor: "rgba(221, 221, 221, 0.875)", color: "black", fontSize: "0.8rem", width: "14rem", height: "2.0rem", marginBottom: "2rem" }}>
                        Toggle Members Only
                    </Button> : <></> }

                    <Box>
                        {editingUser === "" ? printUserRows() : printUserEdit()}
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardUsers;
